/**
 * @module Model.StudentProgramRegistrationModel
 *
 * Represents a student's registration to a program, including registration metadata
 * and the associated student profile.
 */
import { Model } from "typedefs";
import { StudentProfileModel } from "./StudentProfileModel";

export class StudentProgramRegistrationModel implements Model {
  id: number;
  status: string;
  createdAt: string;
  canRemove: boolean;
  paymentMethod: 'offline' | 'online' | null;
  paymentStatus?: 'pending' | 'pending_payment' | 'paid' | 'payment_confirmed' | 'payment_expired' | 'failed' | null;
  onlinePaymentType?: 'send_invoice' | 'card_on_file' | null;
  chargeTiming?: 'immediate' | 'after_session' | null;
  displayStatus: string | null;
  expiresAt?: string;
  invoiceUrl?: string | null;
  sharePaymentUrl?: string | null;
  studentProfile: StudentProfileModel;

  constructor(registration: any, studentProfile: StudentProfileModel) {
    this.id = registration.id;
    this.status = registration.status;
    this.createdAt = registration.createdAt;
    this.canRemove = registration.canRemove;
    this.paymentMethod = registration.paymentMethod;
    this.paymentStatus = registration.paymentStatus || null;
    this.onlinePaymentType = registration.onlinePaymentType || null;
    this.chargeTiming = registration.chargeTiming || null;
    this.displayStatus = registration.displayStatus || null;
    this.expiresAt = registration.expiresAt;
    this.invoiceUrl = registration.invoiceUrl || null;
    this.sharePaymentUrl = registration.sharePaymentUrl || null;
    this.studentProfile = studentProfile;
  }

  /**
   * Alias for id to maintain backward compatibility
   */
  get registrationId(): number {
    return this.id;
  }

  /**
   * Alias for status to provide clear registration status access
   */
  get registrationStatus(): string {
    return this.status;
  }
}
